import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import find from 'lodash/find';
import { Chip } from '@mui/material';
import { hasAuthourity } from '../../../../../lib/access.es6';
import { ClaimTypeEnum } from '../../../lib/enum';
import ViewDocument from '../../../../../shared-ui/ViewDocument/ViewDocument';
import { getPartnerGuid } from "../../../../../lib/access.es6";

const ClaimDocuments = (props) => {
  const classes = useStyle();
  const [viewDocumentUrl, setViewDocumentUrl] = React.useState(null);
  const [numPages, setNumPages] = React.useState(null);
  const partnerGuid = getPartnerGuid();

  console.log("claim documents props", props)

  const claimDocs = props.claimDocuments || [];

  // Mthunzi HospiCash required documents (BRD + test cases CL-TC-015/016).
  const staticHospitalDocs = [
    { description: "ID document *" },
    { description: "Claim form *" },
    { description: "Hospital admission proof *" },
  ];

  const staticHospitalAccidentDocs = [
    { description: "ID document *" },
    { description: "Claim form *" },
    { description: "Hospital admission proof *" },
    { description: "Police Report *" },
  ];

  const staticDeathDocs = [
    { description: "ID document *" },
    { description: "Burial permit *" },
    { description: "Death Certificate *" },
  ];

  const  accidentalDeath = [
  { description: "ID/Passport *" },
    { description: "Burial permit *" },
    { description: "Death Certificate *" },
  ];

  const naturalDeath = [
   { description: "ID/Passport *" },
       { description: "Burial permit *" },
    { description: "Death Certificate *" },
  ];

  const totalPermanentDisability = [
    { description: "ID/Passport *" },
    { description: "Medical Report or Hospital Letter Indicating Permanent Disability *" },
 
  ];
  
  const partialPermanentDisability = [
     { description: "ID/Passport *" },
    { description: "Medical Report or Hospital Letter Indicating Partial Permanent Disability *" },
  ];

  const staticLastExpense = [
    { description: " ID Front *" },
    { description: " ID Back *" },
    { description: "Burial Permit *" },
    { description: "Birth certificate/Marriage certificate *" },
  ];

  const staticPermanentDisabilityDocs = [
    { description: "Claim form *" },
    { description: "Loan form *" },
    { description: "Loan statement *" },
    { description: "Loan repayment schedule *" },
    { description: "Borrower ID Front *" },
    { description: "Borrower ID Back *" },
    { description: "Police abstract *" },
    { description: "Doctors report *" },
  ];
  const staticPropertyDocs = [
    { description: "Claim form *" },
    { description: "Loan form *" },
    { description: "Loan statement *" },
    { description: "Loan repayment schedule *" },
    { description: "Borrower ID Front *" },
    { description: "Borrower ID Back *" },
    { description: "Police abstract *" },
    { description: "Photos of destroyed business *" },
  ];

  let staticDocs = [];
  if (
    props.type === ClaimTypeEnum.FuneralAccidentalDeath ||
    props.type === ClaimTypeEnum.FuneralNaturalDeath
  ) {
    staticDocs = [...staticDeathDocs];
  }
  if (props.type === ClaimTypeEnum.HospiCashIllness) {
    staticDocs = [...staticHospitalDocs];
  }
  if (props.type === ClaimTypeEnum.HospiCashAccident) {
    staticDocs = [...staticHospitalAccidentDocs];
  }
  if (props.type === ClaimTypeEnum.LastExpense) {
    staticDocs = [...staticLastExpense];
  }
  if (props.type === ClaimTypeEnum.permanentDisability) {
    staticDocs = [...staticPermanentDisabilityDocs];
  }
  if (props.type === ClaimTypeEnum.Property) {
    staticDocs = [...staticPropertyDocs];
  }
  if (props.type === ClaimTypeEnum.AccidentalDeath) {
    staticDocs = [...accidentalDeath];
  }
  if (props.type === ClaimTypeEnum.NaturalDeath) {
    staticDocs = [...naturalDeath];
  }
  if (props.type === ClaimTypeEnum.TotalPermanentDisability) {
    staticDocs = [...totalPermanentDisability];
  }
  if (props.type === ClaimTypeEnum.PartialPermanentDisability) {
    staticDocs = [...partialPermanentDisability];
  }
  if (props.type === ClaimTypeEnum.OldMutualMalawiFuneral) {
    staticDocs = [...staticDeathDocs];
  }
  // These document rules are for OMM FUNERAL (death) claims only — a HospiCash
  // claim keeps its hospital docs (no proof-of-death / burial certificate).
  const isOmmFuneral =
    partnerGuid === "old_mutual_malawi" &&
    props.type === ClaimTypeEnum.OldMutualMalawiFuneral;

  if(isOmmFuneral && props.claimDetails.claim_details.additional_details.age < 18){
    staticDocs = staticDocs.filter(doc => doc.description !== "ID document *");
    staticDocs.push({ description: "Burial Certificate  or School ID for Minors or Health Passport if deceased is below 5*" });

  }
   if(isOmmFuneral){
    staticDocs = staticDocs.filter(doc => doc.description !== "Burial permit *" && doc.description !== "Death Certificate *" );
    staticDocs.push({ description: "Proof of death *" });

  }
  if(isOmmFuneral && props.claimDetails.claim_details.additional_details.cause_of_death === "Accidental death"){
    console.log("adding police report")
    staticDocs.push({ description: "Police Report *" });
  }
  if (partnerGuid === "omk") {
    staticDocs.push({ description: "Proof of Payment *" });
    staticDocs.push({ description: "AML Documents *" });
  }

  const missingStaticDocs = [];

  for (let doc of staticDocs) {
    if (!find(claimDocs, { description: doc.description })) {
      missingStaticDocs.push({ ...doc, status: "missing" });
    }
  }

  // Keep the container's missingDocs flag in sync with the CURRENT state (not
  // sticky): once the outstanding docs are uploaded this flips back to false so
  // finalisation is unblocked without a manual page refresh. Guarded so we only
  // update the parent when the value actually changes.
  const hasMissingDocs = missingStaticDocs.length > 0;
  if (props.setMissingDocs && props.missingDocs !== hasMissingDocs) {
    props.setMissingDocs(hasMissingDocs);
  }

  const result = [
    ...missingStaticDocs,
    ...claimDocs,
    { description: "", status: "any other doc" },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Grid container spacing={2} className={classes.claimdocswrapper}>
          <Grid item xs={12} sm={12} md={12}>
            <TableInc
              columns={[
                {
                  title: "Document  Name",
                  field: "description",
                },
                {
                  title: "Status",
                  field: "created_At",
                  render: (rowData) =>
                    rowData.status === "missing" ? (
                      <Chip
                        size="small"
                        variant="outlined"
                        label={"missing"}
                        style={{
                          margin: "1px",
                          backgroundColor: "red",
                          color: "#fff",
                        }}
                      />
                    ) : rowData.status === "any other doc" ? (
                      "upload any other doc"
                    ) : (
                      <Chip
                        size="small"
                        variant="outlined"
                        label={"uploaded"}
                        style={{
                          margin: "1px",
                          backgroundColor: "green",
                          color: "#fff",
                        }}
                      />
                    ),
                },

                {
                  title: "Actions",
                  field: "created_At",
                  render: (rowData) => {
                    return !(
                      rowData.status === "missing" ||
                      rowData.status === "any other doc"
                    ) ? (
                      <div className={classes.actionbtn}>
                        <Tooltip title="View Document">
                          <span
                            onClick={() => setViewDocumentUrl(rowData.url)}
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity("UPDATE_CLAIM")
                                ? "inline"
                                : "none",
                            }}
                          >
                            <VisibilityIcon sx={{ color: " #4B7E34" }} />
                          </span>
                        </Tooltip>

                        <Tooltip title="Download Document">
                          <span
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity("UPDATE_CLAIM")
                                ? "inline"
                                : "none",
                            }}
                          >
                            <a
                              href={rowData.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FileDownloadIcon sx={{ color: " #000" }} />
                            </a>{" "}
                          </span>
                        </Tooltip>

                        <Tooltip title="Delete Document">
                          <span
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity("UPDATE_CLAIM")
                                ? "inline"
                                : "none",
                              marginLeft: "5px",
                            }}
                            onClick={() =>
                              props.setClaimDocumentToDelete(rowData)
                            }
                          >
                            {" "}
                            <DeleteIcon sx={{ color: "#8F191C" }} />
                          </span>
                        </Tooltip>
                      </div>
                    ) : (
                      <div className={classes.actionbtn}>
                        <Tooltip title="Upload Document">
                          <span
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity("UPDATE_CLAIM")
                                ? "inline"
                                : "none",
                              marginLeft: "5px",
                            }}
                            onClick={() => {
                              props.setDescription(rowData.description);
                              props.openUploadDialog();
                            }}
                          >
                            {" "}
                            <FileUploadIcon sx={{ color: "#000" }} />
                          </span>
                        </Tooltip>
                      </div>
                    );
                  },
                },
              ]}
              data={result}
              options={{
                pageSize: 7,
                showTitle: false,
              }}
            />
          </Grid>

          <ViewDocument
            title="View Claim Documents"
            open={viewDocumentUrl}
            close={() => setViewDocumentUrl(null)}
            viewDocumentUrl={viewDocumentUrl}
            numPages={numPages}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ClaimDocuments